import { jsx } from "react/jsx-runtime";
import React from "react";
export default function Cutsite({
  annotationHeight,
  radius
  // totalAngle,
  // ...rest
}) {
  return /* @__PURE__ */ jsx(
    "rect",
    {
      className: "veCutsite",
      width: 1,
      y: -radius - 4,
      height: annotationHeight
    }
  );
}
